export { default } from "./src/content-block";
